module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(!_vm.isLoaded) ? _c('div', {
    ref: "loader",
    class: ['loader', ("loader--" + (_vm.settingsObj.themeColor)), 'loader-bar-ping-pong', "is-active"]
  }) : _vm._e(), _vm._v(" "), _c('iframe', {
    staticClass: "docs",
    attrs: {
      "src": this.$endpoints.base
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57a9d719","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Docs.vue
// module id = 465
// module chunks = 0